import React, { useState, useEffect } from "react";
import instance from "../../instance";
import "../Customer.css";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const DatabaseDetails = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const code = params.get("code");

  const [databaseData, setDatabaseData] = useState(null);
  const [isEditingDatabase, setIsEditingDatabase] = useState(false);
  const [showPasswordDatabase, setShowPasswordDatabase] = useState(false);
  const [databaseFormData, setDatabaseFormData] = useState({
    DatabaseName: "",
    SQLUser: "",
    SQLPassword: "",
    TrustedConnection: "",
  });

  useEffect(() => {
    if (code) {
      fetchDatabaseData();
    } else {
      toast.error("No code provided.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fetchDatabaseData is recreated each render; adding it would refetch on every paint
  }, [code]);

  const fetchDatabaseData = async () => {
    try {
      const response = await instance.get(`database/by-code/${code}`);

      if (response.status !== 200) {
        throw new Error("Failed to fetch database data.");
      }

      const data = response.data;
      if (data && data.data) {
        setDatabaseData(data.data);
        setDatabaseFormData({
          DatabaseName: data.data.DatabaseName || "",
          SQLUser: data.data.SQLUser || "",
          SQLPassword: data.data.SQLPassword || "",
          TrustedConnection: data.data.TrustedConnection || "",
        });
      } else {
        toast.error("No database data found for the given code.");
      }
    } catch (error) {
      console.error("Error fetching database data:", error);
      toast.error("An error occurred while fetching database data.");
    }
  };
  const toggleEditDatabase = () => {
    if (isEditingDatabase) {
      saveDatabaseData();
    } else {
      setIsEditingDatabase(true);
    }
  };

  const handleDatabaseInputChange = (event) => {
    const { id, value } = event.target;
    setDatabaseFormData({ ...databaseFormData, [id]: value });
  };

  const saveDatabaseData = async () => {
    try {
      const response = await instance.put(
        `database/by-code/${code}`,
        databaseFormData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      toast.success("Database info updated successfully!");
      fetchDatabaseData(); // Fetch updated data instead of reloading the page
      setIsEditingDatabase(false); // Exit editing mode
    } catch (error) {
      console.error("Error updating database info:", error);
      toast.error("An error occurred while updating database info.");
    }
  };

  const togglePasswordDatabaseVisibility = () => {
    setShowPasswordDatabase(!showPasswordDatabase);
  };

  return (
    <div>
      <main>
        <section id="database-section">
          <h2>Database Details</h2>
          {databaseData && (
            <ul>
              <li>
                Database Name:{" "}
                <span
                  className={`info ${isEditingDatabase ? "hidden" : ""}`}
                  id="info-DatabaseName"
                >
                  {databaseData.DatabaseName}
                </span>
                {isEditingDatabase && (
                  <input
                    className="input-field"
                    type="text"
                    id="DatabaseName"
                    value={databaseFormData.DatabaseName}
                    onChange={handleDatabaseInputChange}
                    placeholder="Enter the database name"
                  />
                )}
              </li>
              <li>
                User SQL:{" "}
                <span
                  className={`info ${isEditingDatabase ? "hidden" : ""}`}
                  id="info-SQLUser"
                >
                  {databaseData.SQLUser}
                </span>
                {isEditingDatabase && (
                  <input
                    className="input-field"
                    type="text"
                    id="SQLUser"
                    value={databaseFormData.SQLUser}
                    onChange={handleDatabaseInputChange}
                    placeholder="Enter the SQL user"
                  />
                )}
              </li>
              <li>
                Password SQL:{" "}
                <span
                  className={`info3 ${isEditingDatabase ? "hidden" : ""}`}
                  id="info-SQLPassword"
                >
                  {showPasswordDatabase ? databaseData.SQLPassword : "••••••••"}
                </span>
                {isEditingDatabase && (
                  <input
                    className="input-field"
                    type={showPasswordDatabase ? "text" : "password"}
                    id="SQLPassword"
                    value={databaseFormData.SQLPassword}
                    onChange={handleDatabaseInputChange}
                    placeholder="Enter the SQL password"
                  />
                )}
                <button
                  className="show"
                  onClick={togglePasswordDatabaseVisibility}
                >
                  {showPasswordDatabase ? "Hide" : "Show"}
                </button>
              </li>
              <li>
                Trusted Connection:{" "}
                <span
                  className={`info ${isEditingDatabase ? "hidden" : ""}`}
                  id="info-TrustedConnection"
                >
                  {databaseData.TrustedConnection}
                </span>
                {isEditingDatabase && (
                  <input
                    className="input-field"
                    type="text"
                    id="TrustedConnection"
                    value={databaseFormData.TrustedConnection}
                    onChange={handleDatabaseInputChange}
                    placeholder="Enter the trusted connection"
                  />
                )}
              </li>
            </ul>
          )}
          <button className="edit-button" onClick={toggleEditDatabase}>
            {isEditingDatabase ? "Save" : "Update"}
          </button>
        </section>
      </main>
    </div>
  );
};

export default DatabaseDetails;
